const SET_PARTNER = (state, payload) => {
  state.partner = payload;
};

const SET_QR_CODE = (state, payload) => {
  state.qrCode = payload;
};

const SET_KEY_BOARD = (state, payload) => {
  state.withKeyBoard = payload;
};

const SET_PARTNER_MOVING_BOXES = (state, payload) => {
  state.partnerMovingBoxes = payload;
};

const REMOVE_PARTNER = state => {
  state.partner = {};
};

const REMOVE_QR_CODE = state => {
  state.qrCode = {};
};

const REMOVE_MOVING = state => {
  state.partner = {};
  state.qrCode = [];
  state.withKeyBoard = [];
};
export default {
  SET_PARTNER,
  SET_QR_CODE,
  SET_KEY_BOARD,
  SET_PARTNER_MOVING_BOXES,
  REMOVE_PARTNER,
  REMOVE_QR_CODE,
  REMOVE_MOVING
};
